module.exports = "<lfwms-searchable-entity-details [serviceFactory]=\"serviceFactory\"></lfwms-searchable-entity-details>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/reports/maintain-report/maintain-report-home/maintain-report-details/maintain-report-details.component.html
// module id = ../../../../../src/app/features/reports/maintain-report/maintain-report-home/maintain-report-details/maintain-report-details.component.html
// module chunks = main